<template>
  <div class="card-page">
    <b-card no-body class="mb-1">
      <div class="p-1 d-flex align-items-center justify-content-between flex-wrap" style="gap:.5rem">
        <div>
          <h4 class="mb-0">بطاقة متابعة أداء معلم</h4>
          <small class="text-muted">املأ البطاقة وتُحفظ تلقائياً في النظام. للرجوع للسجل اضغط «سجل البطاقات».</small>
        </div>
        <div class="d-flex align-items-center" style="gap:.5rem">
          <b-button variant="primary" size="sm" @click="goList">
            <feather-icon icon="ListIcon" /> سجل البطاقات
          </b-button>
          <b-button variant="outline-primary" size="sm" @click="reload" title="تحديث">
            <feather-icon icon="RefreshCwIcon" />
          </b-button>
        </div>
      </div>
    </b-card>
    <iframe v-if="src" :key="k" :src="src" class="tc-frame" title="بطاقة متابعة أداء معلم"></iframe>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
export default {
  components: { BCard, BButton },
  data() {
    return {
      src: '',
      k: 1,
      user: JSON.parse(localStorage.getItem('user')),
    }
  },
  created() {
    // teacher-access accounts only (the school account passes checkPer anyway)
    if (!checkPer('teachers|view')) {
      this.$router.push('/NotPermitted')
      return false
    }
    this.build()
  },
  methods: {
    build() {
      var base = window.api || localStorage.getItem('api') || ''
      var q = '?api=' + encodeURIComponent(base) + '&jwt=' + encodeURIComponent(this.user.jwt)
      if (this.$route.query.id) q += '&id=' + encodeURIComponent(this.$route.query.id)
      if (this.$route.query.teacher) q += '&teacher=' + encodeURIComponent(this.$route.query.teacher)
      this.src = '/teacher-card.html' + q
    },
    goList() {
      this.$router.push('/_teachers/cards')
    },
    reload() {
      this.k += 1 // remount the iframe to reload the card
    },
  },
}
</script>

<style scoped>
.tc-frame {
  width: 100%;
  height: 82vh;
  min-height: 680px;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}
</style>
